<app-advisor-errorpage *ngIf="hasResult === false"></app-advisor-errorpage>
<div class="grid-container" #resultWrapper *ngIf="hasResult === true">
  <div class="grid-x grid-margin-x headline-wrapper">
    <div class="dialog-hint cell small-12 large-12">
      <dialog-hint [clickTarget]="idTargetElement" aria-live="polite" class="callout-verbrauch" *ngIf="(forceDialog || showDownload) && (anfrage?.userInput?.ladestrom_elektrofahrzeug_verbrauch <= 0 || anfrage?.userInput?.ladestrom_elektrofahrzeug_verbrauch === undefined)" textkey="stromcheck.ergebnis.callout" [closable]="true"></dialog-hint>
      <dialog-hint [showPdfAndPrintIcons]="false" class="callout-update-verbrauch" *ngIf="anfrage?.userInput?.ladestrom_elektrofahrzeug_verbrauch > 0" textkey="stromcheck.ergebnis.callout.update.verbrauch" [closable]="true"></dialog-hint>
    </div>
    <div class="cell small-12 large-offset-1 large-10 text-center">
      <h1 [innerHTML]="textkeyPrefix + '.headline' | translate"></h1>
      <app-analyse [anfrage]="anfrage" [classHasChanged]="classHasChanged"></app-analyse>
    </div>
  </div>
  <div class="cell small-12 large-10 text-center headline-wrapper">
    <h2 [innerHTML]="textkeyPrefix + '.headline.change.result' | translate"></h2>
  </div>

  <app-e-mobility-box [anfrage]="anfrage" (onClassChange)="onClassChange($event)" (onCarElectricityChange)="onCarElectricityChange($event)"></app-e-mobility-box>

  <div class="grid-x grid-margin-x headline-wrapper">
    <div class="cell small-12 large-offset-1 large-10 text-center">
      <h2 [innerHTML]="textkeyPrefix + '.headline.savings' | translate"></h2>
    </div>
  </div>

  <app-savings [anfrage]="anfrage" [carElectricityHasChanged]="carElectricityHasChanged"></app-savings>

  <div class="grid-x grid-margin-x" *ngIf="showDownload" id="stromcheck-download">
    <div class="cell small-12">
      <app-download [id]="idTargetElement" [url]="reportUrl" textkeyPrefix="stromcheck.ergebnis."></app-download>
    </div>
  </div>

  <app-dialogform [id]="idTargetElement" *ngIf="forceDialog" textkeyPrefix="stromcheck" copyright=".dialogform.copyright" advisorImagePath="/stc/stc-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)"></app-dialogform>

  <app-advisor-teaser *ngIf="sdcUrl && anfrage.userInput.photovoltaik_vorhanden === 'nein' && anfrage.userInput.gebaeudetyp !== 'mehrfamilienhaus'" [changeColumnOrder]="true" [url]="sdcUrl" [mailUrl]="sdcUrl" textPrefix="stromcheck.ergebnis.teaser.sdc" image="/stc/sdc-teaser.svg"></app-advisor-teaser>
  <app-advisor-teaser *ngIf="wpcUrl && showWpcAdvisorteaser && anfrage.userInput.gebaeudetyp !== 'mehrfamilienhaus' && anfrage.userInput.waermepumpe_vorhanden !== 'ja'" [url]="wpcUrl" [mailUrl]="wpcUrl" textPrefix="stromcheck.ergebnis.teaser.wpc" image="/stc/wpc-teaser.svg"></app-advisor-teaser>
  <app-advisor-teaser *ngIf="hecUrl && showWpcAdvisorteaser && anfrage.userInput.gebaeudetyp !== 'mehrfamilienhaus' && anfrage.userInput.waermepumpe_vorhanden === 'ja'" [url]="hecUrl" [mailUrl]="hecUrl" textPrefix="stromcheck.ergebnis.teaser.hec" image="/stc/moc-teaser.svg"></app-advisor-teaser>

  <app-portal-teaser></app-portal-teaser>

  <app-donate *ngIf="internalPortal === true" textkeyPrefix="stromcheck"></app-donate>
</div>

<div class="grid-x grid-padding-x" *ngIf="hasResult === true">
  <div class="cell">
    <app-step-buttons previousLink="../../eingabe/verbrauchsdaten"
                      mediumWidthRight="10" mediumOffset="auto" leftAlignSize="" largeOffset="auto" largeWidthRight="10"
                      previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
  </div>
</div>
